import { createSlice } from '@reduxjs/toolkit';
import type { OrigemPedidoState } from '../../types/origemPedidoTypes';
import { consultarOrigemPedido } from './actions';
import { chaveConsultaOrigem } from './chaveConsulta';

const initialState: OrigemPedidoState = {
  consultas: {},
};
const slice = createSlice({
  name: 'origemPedido',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(consultarOrigemPedido.pending, (state, action) => {
        const chave = chaveConsultaOrigem(action.meta.arg);
        state.consultas[chave] = {
          consulta: action.meta.arg,
          resultado: state.consultas[chave]?.resultado ?? null,
          requestId: action.meta.requestId,
          loading: true,
          error: null,
        };
      })
      .addCase(consultarOrigemPedido.fulfilled, (state, action) => {
        const consulta = state.consultas[chaveConsultaOrigem(action.meta.arg)];
        if (consulta?.requestId !== action.meta.requestId) return;
        consulta.resultado = action.payload;
        consulta.loading = false;
      })
      .addCase(consultarOrigemPedido.rejected, (state, action) => {
        const consulta = state.consultas[chaveConsultaOrigem(action.meta.arg)];
        if (consulta?.requestId !== action.meta.requestId) return;
        consulta.resultado = null;
        consulta.error = action.payload ?? 'Origem indisponível';
        consulta.loading = false;
      }),
});
export const origemPedidoReducer = slice.reducer;
